import { useCallback, useState } from 'react';

// Sincroniza um único produto (linha da tabela de busca), controlando qual
// código está em andamento para desabilitar só o botão daquela linha.
export function useSingleSync(syncFn) {
  const [syncingCode, setSyncingCode] = useState(null);

  const syncOne = useCallback(
    async (product) => {
      if (!product || !product.code) return;
      setSyncingCode(product.code);
      try {
        await syncFn(product);
      } finally {
        setSyncingCode(null);
      }
    },
    [syncFn]
  );

  return { syncingCode, syncOne };
}
